const TOKEN_KEY = 'cim_token';
const VERSION_KEY = 'cim_web_session_version';
export function authVersion() { return localStorage.getItem(VERSION_KEY) || ''; }
function advanceSession() { localStorage.setItem(VERSION_KEY, Date.now() + ':' + Math.random()); }
const USER_KEY = 'cim_user';

export function getToken() {
  return localStorage.getItem(TOKEN_KEY) || '';
}

export function setToken(token, refreshed = false) {
  if (!refreshed) advanceSession();
  localStorage.setItem(TOKEN_KEY, token);
}

export function clearToken() {
  advanceSession();
  localStorage.removeItem(TOKEN_KEY);
}

export function getUser() {
  const raw = localStorage.getItem(USER_KEY);
  return raw ? JSON.parse(raw) : null;
}

export function setUser(user) {
  localStorage.setItem(USER_KEY, JSON.stringify(user));
}

export function clearUser() {
  localStorage.removeItem(USER_KEY);
}

export function clearAuth() {
  clearToken();
  clearUser();
}
